{
  "Thank you for filling in the form.": "Bedankt voor het invullen van het formulier.",
  "There was an error in your submission, please try again in a few seconds. If the issue persists, please contact us.": "Er is een fout opgetreden bij uw inzending, probeer het over een paar seconden opnieuw. Als het probleem zich blijft voordoen, neem dan contact met ons op."
}
